import { CMS_MEDIA_BASE_URL } from '@zep/apis';

import { isProduction } from '../utils/common';

/** @deprecated `CMS_MEDIA_BASE_URL`(@zep/apis) 로 직접 import 할 것. 재수출 호환용. */
export const CMS_CDN = CMS_MEDIA_BASE_URL;

export const googleTagManagerId = process.env.NEXT_PUBLIC_GTM_ID?.trim();

// GTM은 프로덕션에서만, 그리고 컨테이너 ID 형식이 유효할 때만 로드한다.
export const shouldLoadGoogleTagManager =
  isProduction &&
  Boolean(googleTagManagerId) &&
  /^GTM-[A-Z0-9]+$/.test(googleTagManagerId ?? '');
